import { Staff } from '../lib/staff';

export type ServiceProviderPermissionId = (typeof Permissions)[number]['id'];
export const Permissions = <const>[
  {
    id: 'svp_ViewServiceProviders',
    display: {
      title: 'View Service Providers',
      description: 'View the table of service providers',
    },
  },
  {
    id: 'svp_ViewServiceProvider',
    display: {
      title: 'View Service Provider',
      description: 'View individual service provider details',
    },
  },
  {
    id: 'svp_CreateServiceProvider',
    display: {
      title: 'Create Service Provider',
      description: 'Create a new service provider',
    },
  },
  {
    id: 'svp_EditDetails',
    display: {
      title: 'Edit Service Provider Details',
      description: 'Edit the details of a service provider',
    },
  },
  {
    id: 'svp_EditStatus',
    display: {
      title: 'Edit Service Provider Status',
      description: 'Activate or deactivate a service provider',
    },
  },
];
Permissions.forEach(p => new Staff.Security.Permission(p));
